<div class="p-4 d-flex flex-column justify-content-center align-items-center text-center" style="height: 100%; min-height: 200px;">
  <div class="d-flex align-items-center gap-2 mb-4">
    <h5 class="mb-0">Contattaci</h5>
    <mat-icon>person_pin</mat-icon>
  </div>
  
  <div class="link-container w-100 mb-2">
    <p>{{ text }}</p>

    <mat-form-field appearance="outline" class="w-100">

      <mat-label>La nostra mail</mat-label>
      <input 
        matInput 
        [value]="invoicingEmail" 
        readonly
        #linkInput>
      <button 
        mat-icon-button 
        matSuffix 
        (click)="copyToClipboard()"
        [attr.aria-label]="'Copia link'">
        <mat-icon>content_copy</mat-icon>
      </button>
    </mat-form-field>
  </div>

  <div *ngIf="invoicingEmail === 'info@izysrl.it' && data.organization && data.organization.is_only_invoicing==false" class="mb-3 actions d-flex gap-2 w-100">
    <button 
      mat-raised-button 
      color="primary" 
      class="flex-fill" 
      (click)="copyAndRedirect()">
      <mat-icon>category_search</mat-icon>
      Esplora i nostri servizi aggiuntivi
    </button>
  </div>

  <div class="actions d-flex gap-2 w-100">
    <button 
      mat-button
      mat-dialog-close 
      class="flex-fill" 
      (click)="onCancel()">
      Esci
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      class="flex-fill" 
      (click)="copyToClipboard()">
      <mat-icon>content_copy</mat-icon>
      Copia mail
    </button>
  </div>
</div>
